export default __webpack_public_path__ + "static/media/phone-support-mobile.42195922.png";